import script from "./SupervisionDeviceTab.vue?vue&type=script&setup=true&name=SupervisionDeviceTab&lang=js"
export * from "./SupervisionDeviceTab.vue?vue&type=script&setup=true&name=SupervisionDeviceTab&lang=js"

import "./SupervisionDeviceTab.vue?vue&type=style&index=0&id=bba8843e&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba8843e"]])

export default __exports__